import React, { useContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import PassportLogo from "../assets/img/passport-logo.png";
import LoaderGlass from "../assets/svg/LoaderGlass";
import { ImmutablePassport, Toast } from "../utils/Global";
import { useSphereOneProvider } from "../utils/SphereOneHooks";
import OTPInput from "../components/OTP";
import Popup from "../components/Popup";
import InputWallet from "../components/InputWallet";
import { Context } from "../context/WalletContext";
import { passportInstance } from "../context/PassportService";
import styled from "styled-components";
import WalletManagerModal from "../components/Modals/WalletManagerDialog";

const qorbiServices = require("../context/QorbiService");

const StyledProfilePage = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: start;
  padding-top: 10vh;
  gap: 35px;

  .left-side-profile,
  .right-side-profile {
    display: flex;
    width: 600px;
    flex-direction: column;
    justify-content: start;
    align-items: center;
  }

  .profile-main-rectangle {
    width: 600px;
    height: 93px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 24px;
    border-width: 0px;
    padding: 24px;
    background: #1c1c1c;
    border-style: solid;
  }

  .profile-username {
    color: #ffffff;
    font-weight: 400;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0%;
    margin: 0px;
  }

  .wallet-level-container {
    flex: 2;
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .manage-wallets-container {
    width: 150px;
    height: 30px;
    border-radius: 14px;
    padding: 10px;
    background: linear-gradient(#38ef7d, #11998e);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 16px;
    font-family: Exo 2;
    font-weight: 500;
    font-size: 14px;
    leading-trim: Cap height;
    line-height: 100%;
    letter-spacing: 0%;
  }

  .manage-wallets-text {
    margin: 0px;
    color: #ffffff;
    font-weight: 500;
    font-size: 14px;
    leading-trim: Cap height;
    line-height: 100%;
    letter-spacing: 0%;
  }

  .user-level-container {
    width: 80px;
    height: 30px;
    border-radius: 16px;
    border-width: 0.4px;
    border-color: #38ef7d;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    leading-trim: Cap height;
    line-height: 100%;
    letter-spacing: 0%;
    border-style: solid;
    color: #ffffff;
  }

  .profile-secondary-rectangle {
    width: 600px;
    height: 284px;
    border-radius: 24px;
    border-width: 0.4px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    background: #1c1c1c;
    margin-top: 32px;
  }

  .profile-info-row {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: start;
  }

  .profile-info-key {
    font-family: Exo 2;
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #ffffff;
  }

  .profile-info-value {
    font-family: Exo 2;
    font-weight: 300;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: right;
    color: #38ef7d;
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .copy-icon {
    margin-left: 16px;
    cursor: pointer;
  }

  .profile-tournaments-title {
    width: 100%;
    height: 58px;
    justify-content: space-between;
    border-radius: 21px;
    border-width: 0.4px;
    padding: 16px;
    background: #1c1c1c;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-weight: 500;
    font-size: 22px;
    line-height: 100%;
    letter-spacing: 0%;
    margin-bottom: 32px;
  }

  #hot-news-container {
    width: 100%;
    gap: 24px;
    border-radius: 24px;
    border-width: 0.4px;
    padding: 24px;
    background: #1c1c1c;
    display: flex;
    flex-direction: column-reverse;
    justify-content: start;
    align-items: start;
  }

  .hot-new-tile {
    width: 100%;
    height: 53px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title-date-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
  }

  .go-button {
    width: 70px;
    height: 30px;
    border-radius: 16px;
    border-width: 0.4px;
    padding: 10px;
    background: #323232;
    border-color: #38ef7d;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    leading-trim: Cap height;
    line-height: 100%;
    letter-spacing: 0%;
    color: #ffffff;
    cursor: pointer;
    text-decoration: none;
  }

  .new-title {
    font-family: Exo 2;
    font-weight: 500;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #ffffff;
  }

  .new-date {
    font-family: Exo 2;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #38ef7d;
  }

  #empty-news-container {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 18px;
  }

  .qorbi-balance-container {
    margin-top: 32px;
    width: 100%;
    height: 225px;
    border-radius: 24px;
    border-width: 0.4px;
    padding: 24px;
    background: #1c1c1c;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .balance-title {
    font-family: Exo 2;
    font-weight: 300;
    font-size: 20px;
    line-height: 26px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color: #ffffff;
    margin: 0px;
  }

  .balance-value {
    font-family: Exo;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color: #38ef7d;
    margin: 0px;
  }

  #withdraw-button {
    width: auto;
    height: 51px;
    gap: 10px;
    border-radius: 14px;
    padding: 16px;
    text-align: center;
    background: linear-gradient(#38ef7d, #11998e);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    cursor: pointer;
  }

  @media (width <= 800px) {
    flex-direction: column;
    margin-top: 25%;
    height: 100%;
    padding: 0px 10px 0px 10px;

    .left-side-profile,
    .right-side-profile {
      width: 100%;
    }

    .profile-main-rectangle {
      width: 100%;
    }

    .profile-secondary-rectangle {
      width: 100%;
    }
  }
`;

const UserProfile = () => {
  
  const { localLogin, state } = useContext(Context);
  const {
    setRegisterUser,
    setQorbiUserData,
    qorbiUserData,
  } = useSphereOneProvider();
  const [loading, setLoading] = useState(true);
  const [currency, setCurrency] = useState();
  const [showOTP, setShowOTP] = useState(false);
  const [OTP, setOTP] = useState();
  const [hotNews, setHotNews] = useState([]);
  const [walletInput, setWalletInput] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const manageWalletModal = useRef();

  const isLoggedIn = state.user !== null;

  const getNews = async () => {
    const hotNewsResponse = await axios.get(`https://api.qorbiworld.com/v1/hotnews`);
    setHotNews(hotNewsResponse.data);
  };

  useEffect(() => {
    getNews();
    try {
      passportInstance.loginCallback();
    } catch (error) {
      console.error(error);
    }

    if (qorbiUserData) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qorbiUserData]);

  const handleOtpSubmit = async (otpCode) => {
    setShowOTP(false);
    setOTP(otpCode);
    setWalletInput(true);
  };

  const sendFunds = async (address) => {
    try {
      Toast.set({
        show: true,
        desc: "We are starting the withdraw, wait for a second!",
        type: "success",
      });
      setWalletInput(false);
      await qorbiServices.withdrawToken(address, OTP, currency);
      Toast.set({
        show: true,
        desc: `Success! You have withdrew the $${currency} balance from your Account!`,
        type: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseOtpSubmit = () => {
    setShowOTP(false);
  };

  const connect_Passport = async () => {
    try {
      setLoading(true);
      const provider = passportInstance.connectEvm();
      const accounts = await provider.request({
        method: "eth_requestAccounts",
      });
      const userInfo = {
        authType: ImmutablePassport,
        data: accounts[0],
        isWombat: undefined,
      };
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      try {
        const userResponse = await qorbiServices.userByToken();
        setQorbiUserData(userResponse);
      } catch (error) {
        setRegisterUser(true);
      }
      localLogin(userInfo);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
    window.location.reload();
  };

  const handleWithdraw = async (currency) => {
    setCurrency(currency);
    if (qorbiUserData.tokensBalance.QORBI < 7000 && currency === "QORBI") {
      setShowPopup({
        title: "Not Enough Balance!",
        content:
          `You need at least 7,000 $${currency} to withdraw—keep grinding, gamer!`,
      });
      return;
    } else {
      qorbiServices.requestOtp();
      setShowOTP(true);
    }
  };

  if (loading || !isLoggedIn) {
    return (
      <div className="loading-magnifying-glass">
        <LoaderGlass></LoaderGlass>
        <h1 className="banner-title">
          Getting Information from the librarian!!!
        </h1>
        <h2 className="banner-title">Yes, we have a librarian...</h2>
        <div className="signin-overlay">
          <div className="signin-box">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h1>SIGN IN</h1>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="welcome">
                <p style={{ marginRight: 3 }}>Welcome to</p>
                <p style={{ color: "green" }}>Qorbi World</p>
              </div>
            </div>
            <p className="welcome">Login using Gmail-Email-Apple</p>
            <div className="signin-buttons">
              <button
                onClick={connect_Passport}
                style={{ backgroundColor: "#14b3cb" }}
              >
                <img
                  src={PassportLogo}
                  alt="Passport Logo"
                  width={25}
                  height={25}
                />{" "}
                Login with Passport
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <StyledProfilePage>
      {/* {toastMsg && <ErrorShowing errorText={toastMsg} />} */}
      <WalletManagerModal ref={manageWalletModal}></WalletManagerModal>
      {walletInput && <InputWallet onSuccess={sendFunds} currency={currency} />}
      {showPopup && (
        <Popup
          onClose={() => setShowPopup(false)}
          title={showPopup.title}
          content={
            <>
              <p>{showPopup.content}</p>
            </>
          }
        />
      )}
      <div className="left-side-profile">
        <div className="profile-main-rectangle">
          <div className="user-avatar"></div>
          <p className="profile-username">{qorbiUserData?.username}</p>
          <div className="wallet-level-container">
            <div
              className="manage-wallets-container"
              onClick={() => manageWalletModal.current.open()}
            >
              <p className="manage-wallets-text">Manage Wallets</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#e3e3e3"
              >
                <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
              </svg>
            </div>
            <div className="user-level-container">
              Level: {qorbiUserData?.rank?.level}
            </div>
          </div>
        </div>

        <div className="qorbi-balance-container">
          <p className="balance-title">Current Balance</p>
          <p className="balance-value">
            {qorbiUserData?.tokensBalance?.QORBI || 0} QORBI
          </p>
          <p className="balance-value">
            {qorbiUserData?.tokensBalance?.FATE || 0} FATE
          </p>
          <p className="balance-value">
            Tap Pass: {qorbiUserData?.tapPass ? 'Active' : 'Inactive'}
          </p>
          <div style={{ display: "flex", width: "100%", justifyContent: "space-around", gap: "10px" }}>
            <div id="withdraw-button" onClick={() => handleWithdraw('QORBI')}>
              Withdraw QORBI
            </div>
            <div id="withdraw-button" onClick={() => handleWithdraw('FATE')}>
              Withdraw FATE
            </div>
          </div>

        </div>
        <div className="profile-secondary-rectangle">
          <div className="profile-info-row">
            <p className="profile-info-key">Session Wallet:</p>
            <div className="profile-info-value">
              {state?.user?.data.substring(0, state?.user?.data.length - 15)}...
              <div
                className="copy-icon"
                onClick={function () {
                  return navigator.clipboard.writeText(state?.user?.data);
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9H16C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16V15Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className="profile-info-row">
            <p className="profile-info-key">Winrate:</p>
            <p className="profile-info-value">
              {qorbiUserData?.winrate || "N/A"}
            </p>
          </div>
          <div className="profile-info-row">
            <p className="profile-info-key">Score:</p>
            <p className="profile-info-value">
              {qorbiUserData?.rank.totalScore}
            </p>
          </div>

          <div className="profile-info-row">
            <p className="profile-info-key">Referral Code:</p>
            <div className="profile-info-value">
              {qorbiUserData?.referalCode || "Generating"}
              <div
                className="copy-icon"
                onClick={function () {
                  return navigator.clipboard.writeText(
                    qorbiUserData?.referalCode
                  );
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9H16C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16V15Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showOTP && (
        <OTPInput onSubmit={handleOtpSubmit} onCancel={handleCloseOtpSubmit} />
      )}
      <div className="right-side-profile">
        <div className="profile-tournaments-title">Hot News</div>
        <div id="hot-news-container">          
          {hotNews.length > 0 ? (
            hotNews.map((element) => (
              <div className="hot-new-tile" key={element._id}>
                <div className="title-date-container">
                  <p className="new-title">{element.simpleText}</p>
                </div>
                <div className="spacer"></div>
                {element.link && (
                  <a className="go-button" target="_blank" href={element.link} rel="noreferrer">
                    Go Now
                  </a>
                )}
              </div>
            ))
          ) : (
            <div id="empty-news-container">No Urgent News</div>
          )}
        </div>
      </div>
    </StyledProfilePage>
  );
};

export default UserProfile;
